import React from "react";
import not from "ramda/src/not";

import { Modal } from "../Modal";
import Api from "../../services/Api";
import { useModalContext } from "../../contexts/ModalContext/context";
import { EMAIL_ADDRESS, PHONE_NUMBER } from "../../constants/general";
import useAuth from "../../routes/login/AuthContext";
import { normalize } from "../../helpers/normalize";
import { useSelectedNetworkContext } from "../../contexts/NetworkContext/context";
import { Button } from "../../UI/Button";
import { Typography } from "../../UI/Typography";
import { Checkbox } from "../../UI/Checkbox";
import { useSnackbar } from "../../hooks/useSnackbar";
import { Box } from "../../UI/Box";

interface IProps {
  file?: File;
  onSuccess: VoidFunction;
}

export const UploadBlockedWordsConfirmModal: React.FC<IProps> = (props) => {
  const { showErrorSnackbar } = useSnackbar();
  const [accepted, setIsAccepted] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(false);
  const { setIsOpen } = useModalContext();
  const { selectedNetworkId } = useSelectedNetworkContext();
  const { getAuthToken } = useAuth();

  const handleClose = () => setIsOpen(false);

  const toggleAccepted = () => setIsAccepted(not);

  const handleUpdate = React.useCallback(async () => {
    if (!props.file) {
      return;
    }

    setIsLoading(true);

    const formData = new FormData();
    formData.append("file", props.file);

    const res = await Api.postProfanityFilter(selectedNetworkId, formData, {}, await getAuthToken());

    setIsLoading(false);

    if (res.error) {
      showErrorSnackbar();
    } else {
      props.onSuccess();
      setIsOpen(false);
    }
  }, [selectedNetworkId, normalize(props.file)]);

  return (
    <Modal
      maxWidth="sm"
      title="Confirm Blocked Words Replacement"
      actions={
        <>
          <Button onClick={handleClose}>Cancel</Button>
          <Button appearance="primary" isDisabled={!accepted} isLoading={isLoading} onClick={handleUpdate}>
            Finalize Replacement
          </Button>
        </>
      }
    >
      <Box px={3}>
        {props.children}
        <Typography gutterBottom>
          If you have any questions, contact
          <a href={`mailto:${EMAIL_ADDRESS}`}> {EMAIL_ADDRESS}</a> or call {PHONE_NUMBER}.
        </Typography>
        <Checkbox
          label="I understand that the list of options above will completely replace my current blocked words options."
          isChecked={accepted}
          onChange={toggleAccepted}
        />
      </Box>
    </Modal>
  );
};
